/**
 *
 * OptionalPermissionedRoute
 *
 * Customized route that redirects non-authorised users back to the homepage
 *
 * NB: if ANY of the optional features are found within the user's accessible features list - permission is granted
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import session from '../../App/session';
import { isEmpty } from 'lodash';
import { Skeleton } from 'antd';

/**
 * @description determine if an array contains one or more items from another array.
 * @param {array} haystack the array to search.
 * @param {array} arr the array providing items to check for in the haystack.
 * @return {boolean} true|false if haystack contains at least one item from arr.
 */
const findOne = (haystack, arr) => arr.some((v) => haystack.includes(v));

const OptionalPermissionedRoute = ({ optionalFeatures }) => {
    const accessibleFeatures = useSelector(session.selectors.selectAccessibleFeatures);
    // Wait until accessibleFeatures is loaded
    if (isEmpty(accessibleFeatures)) {
        return (
            <>
                <Skeleton active />
                <Skeleton active />
                <Skeleton active />
            </>
        );
    }
    const isAuthorized = findOne(accessibleFeatures, optionalFeatures);
    if (!isAuthorized) return <Navigate to="/" />;
    return <Outlet />;
};

OptionalPermissionedRoute.propTypes = {
    optionalFeatures: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default OptionalPermissionedRoute;
